/**
 * Session page columns. Beta (composer panel): white work areas, one slate-50 column header as tall
 * as the panel's tabs + toolbar (2 × h-12) so the two line up, and the panel's own left border as the
 * only line between the columns. Everyone else keeps the original layout.
 */
export const sessionLayoutClasses = {
  beta: {
    columnHeader:
      'flex flex-wrap items-center gap-3 border-border border-b bg-slate-50 px-4 py-3 md:min-h-24 md:justify-between md:px-6 md:py-0',
    resizer: 'group relative hidden w-px cursor-col-resize transition-colors hover:bg-primary md:block',
    panelColumn: 'z-20 hidden md:block',
  },
  legacy: {
    columnHeader:
      'flex flex-wrap items-center gap-3 border-border border-b bg-slate-50/50 px-4 py-3 md:justify-between md:px-6 md:py-4',
    resizer: 'group relative hidden w-1 cursor-col-resize bg-border transition-colors hover:bg-primary md:block',
    panelColumn: 'z-20 hidden border-border border-l bg-slate-50 shadow-slate-200/50 shadow-xl md:block',
  },
};
